const state = () => ({
    notifications: [],
    toNotify: {},
    unreadNotifications: 0,
    showNotificationBadge: false,
});

const mutations = {
    setNotification(state, notification) {
        notification.type = notification.type.toString().toLowerCase();
        state.notifications.unshift(notification);
        state.unreadNotifications += 1;
        state.showNotificationBadge = true;
    },
    setToNotify(state, notification) {
        notification.type = notification.type.toString().toLowerCase();
        state.toNotify = notification;
    },
    clear_notification_all(state) {
        state.notifications = [];
        state.unreadNotifications = 0;
        state.showNotificationBadge = false;
    },
    read_notification(state) {
        state.unreadNotifications = 0;
        state.showNotificationBadge = false;
    },
    clear_notification(state, index) {
        state.notifications.splice(index, 1);
        state.unreadNotifications = 0;
    },
};

const actions = {
    directNotification({ commit }, data) {
        commit('setNotification', data);
        commit('setToNotify', data);
    },
    clearAllNotification({ commit }) {
        commit('clear_notification_all');
    },

    readNotification({ commit }) {
        commit('read_notification');
    },

    clearNotification({ commit }, index) {
        commit('clear_notification', index);
    },
};

export default {
    state,
    mutations,
    actions,
};
